import React from 'react'
import cn from 'classnames'

import styles from './styles.module.scss'
import Button from '../../UI/Button/Button'

const OVERLAY_PADDING = 8

const getRect = (el) => {
  if (!el) return null
  const rect = el.getBoundingClientRect()
  if (!rect || rect.width === 0 || rect.height === 0) return null
  return rect
}

const MobileTourSheet = ({ run, steps, onEvent, onFinish }) => {
  const [index, setIndex] = React.useState(0)
  const [rect, setRect] = React.useState(null)

  React.useEffect(() => {
    if (!run) return
    setIndex(0)
  }, [run])

  const step = Array.isArray(steps) ? steps[index] : null

  React.useEffect(() => {
    if (!run || !step) return

    const next = () => {
      const el = typeof step.target === 'string' ? document.querySelector(step.target) : null
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' })
      }

      window.setTimeout(() => {
        const nextRect = getRect(el)
        setRect(nextRect)
      }, 350)

      if (typeof onEvent === 'function') {
        onEvent({ type: 'step:before', index, step })
      }
    }

    next()

    return () => {
      if (typeof onEvent === 'function') {
        onEvent({ type: 'step:after', index, step })
      }
    }
  }, [run, index, step, onEvent])

  const close = (status) => {
    setRect(null)
    if (typeof onFinish === 'function') onFinish(status)
  }

  const onNext = () => {
    if (!steps || index >= steps.length - 1) {
      close('finished')
      return
    }
    setIndex((prev) => prev + 1)
  }

  const onBack = () => {
    if (index <= 0) return
    setIndex((prev) => prev - 1)
  }

  if (!run || !step) return null

  const size = steps?.length || 0

  const highlightStyle = rect
    ? {
        top: Math.max(0, rect.top - OVERLAY_PADDING),
        left: Math.max(0, rect.left - OVERLAY_PADDING),
        width: Math.min(window.innerWidth, rect.width + OVERLAY_PADDING * 2),
        height: Math.min(window.innerHeight, rect.height + OVERLAY_PADDING * 2),
        borderRadius: step?.styles?.spotlight?.borderRadius ?? 12,
      }
    : null

  return (
    <div className={styles.root}>
      <div className={styles.overlay} role='presentation'>
        {highlightStyle && <div className={styles.highlight} style={highlightStyle} />}
      </div>

      <div className={styles.sheet}>
        <div className={styles.header}>
          <div className={styles.title}>
            Guide by web application ({index + 1}/{size})
          </div>
          <Button theme='text' size='normal' className={styles.skip} onClick={() => close('skipped')}>
            Skip
          </Button>
        </div>

        <div className={styles.content}>{step.content}</div>

        <div className={cn(styles.footer, { [styles.footerSingle]: index === 0 })}>
          {index > 0 ? (
            <Button theme='bordered' size='small' className={styles.prev} onClick={onBack}>
              Back
            </Button>
          ) : null}

          <Button theme='bordered' size='small' className={styles.next} onClick={onNext}>
            {index >= size - 1 ? 'Done' : 'Next'}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default MobileTourSheet
